<template>
  <treeselect :placeholder="$t('active_project')"
    class="w-25" :clearable="false"
    :options="options"
    :value="activeProjectId"
    @input="setActive" />
  <!--:load-options="autoCompleteProject"-->
  <!--:async="true" :defaultOptions="true"-->
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import VT from '@/store/types';

import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  mounted() {
  },
  data() {
    return {
    };
  },
  components: {
    Treeselect
  },
  computed: {
    ...mapGetters('Auth', ['projects']),
    ...mapState('Auth', ['activeProjectId']),
    options() {
      return this.projects
        .map((i) => ({
          id: i.id,
          label: `${i.id} ${i.name} (${i.role || 'sysadmin'})`,
        }));
    }
  },

  methods: {
    ...mapActions('Auth', { setActive: VT.SET_ACTIVE_PROJECT }),

    autoCompleteProject({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const options = this.projects
          .filter((item) => searchQuery === '' || (item.name.search(new RegExp(searchQuery, 'i')) !== -1))
          .map((i) => ({
            id: i.id,
            label: `${i.id} ${i.name} (${i.role || 'sysadmin'})`,
          }));
        callback(null, options);
      }
    },
  }
};
</script>
<style lang="scss" scoped>

</style>
